import { z } from 'zod';

/** 后端出错时统一的响应体，前端照这个形状读错误。 */
export const apiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    /** 校验失败时是 zod 的 issue 列表，其它情况可能没有。 */
    issues: z.unknown().optional(),
  }),
});

export type ApiError = z.infer<typeof apiErrorSchema>;

export const healthSchema = z.object({
  status: z.literal('ok'),
  /** 数据库能否连上，前端拿它区分「后端活着但库挂了」。 */
  database: z.enum(['up', 'down']),
  uptimeSeconds: z.number(),
});

export type Health = z.infer<typeof healthSchema>;
